import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../../context/ConfigurationContext'

const SummaryContainer = props => {
  const { configurations } = useContext(ConfigurationContext);
  if(!configurations) return <Redirect to='/'/>;

  return (
    <div className={"py-5 sm:py-20 bg-bottom bg-no-repeat container-outer"}>
      <div className={"container max-w-4xl px-5 sm:px-10 md:px-20 mx-auto"}>
        {props.children}
      </div>
    </div>
  );
};

export default SummaryContainer;
